<template>
  <!-- 求职状态组件 -->
  <!-- ApplyForAJob等于1时正常显示 求职状态  不等于1时显示求职状态编辑栏 -->
  <div :class="ApplyForAJob == 1 ? 'normal' : 'editor'">
    <!-- 正常展示的求职状态 -->
    <div v-if="ApplyForAJob == 1" class="NormalDisplay">
      <p>找工作</p>
      <p>
        {{
          Select == "0"
            ? "离职-想找工作"
            : Select == "1"
            ? "在职-想换工作"
            : Select == "2"
            ? "在职-寻找机会"
            : Select == "3"
            ? "在职-不考虑"
            : ""
        }}
      </p>
    </div>
    <!-- 求职状态编辑栏 -->
    <div v-else class="StartEditing">
      <div class="StartEditing-box">
        <p class="title-p"><span style="color: red">*</span>求职状态：</p>
        <p
          v-for="(item, index) in listArr"
          :key="index"
          :class="Select == item.id ? 'Select-p' : ''"
          @click="handelClickSelect(item)"
        >
          {{ item.name }}
        </p>
      </div>
      <div class="StartEditing-submit">
        <p class="Cancel" @click="handelUnEdit">取消</p>
        <p class="verify" @click="handelSubmitEdit">确认</p>
      </div>
    </div>
  </div>
</template>

<script>
// 引入接口
import {
  updateUserResumes, //
} from "../../../../../../assets/api/CenterJane";
export default {
  // 接收父组件传过来的数据
  props: {
    ApplyForAJob: {},
    data: {},
  },
  data() {
    return {
      //   Editor: "1", //1正常展示个人信息  2编辑个人信息
      listArr: [
        { name: "离职-想找工作", id: "0" },
        { name: "在职-想换工作", id: "1" },
        { name: "在职-寻找机会", id: "2" },
        { name: "在职-不考虑", id: "3" },
      ], // 循环出 求职状态中的几条选项
      Select: "0", // 求职状态的选中
      newSelect: "",
    };
  },
  watch: {
    // 监听 年龄是否满16
    data: {
      handler(newSs) {
        if (newSs === undefined || newSs === null || newSs === "") return;
        this.newSelect = String(newSs);
        this.Select = String(newSs);
      },
      immediate: true,
    },
  },
  components: {},
  methods: {
    // 点击选择求职状态
    handelClickSelect(item) {
      this.Select = item.id;
    },
    // 取消编辑
    handelUnEdit() {
      this.Select = this.newSelect;
      // 子组件传参父组件
      this.$emit("handelUnEdit", 1);
    },
    // 编辑提交
    handelSubmitEdit() {
      var data = {
        data: {
          userId: this.$store.getters.getUser.id,
          jobStatus: this.Select,
        },
      };
      updateUserResumes(data).then((res) => {
        if (res.code == 0) {
          // 成功
          this.$tool.PromptBox("success", "修改成功");
          // 修改成功后应是传参给父组件让父组件刷新简历信息，但暂时没有简历信息接口
          this.$emit("handelSubmitEdit", 1);
        } else {
          // 失败
          // this.$tool.PromptBox("error", res.msg);
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
// 正常显示的div
.normal {
  width: 100%;
  min-height: 25px;
}
// 编辑栏的div
.editor {
  width: 100%;
  min-height: 25px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
}

// 正常展示
.NormalDisplay {
  width: 100%;
  display: flex;
  p {
    font-size: 12px;
    color: #333333;
    font-weight: 400;
    line-height: 23px;
  }
  p:nth-child(1) {
    min-width: 50px;
    height: 23px;
    background: #409eff ;
    border-radius: 5px;
    text-align: center;
    color: #ffffff;
    margin-right: 20px;
  }
}
// 开始编辑
.StartEditing {
  flex: 1;
  margin: 30px 20px 20px 30px;
  display: flex;
  flex-direction: column;
  .StartEditing-box {
    width: 100%;
    height: 35px;
    display: flex;
    margin-bottom: 20px;
    p {
      height: 35px;
      line-height: 35px;
      font-size: 12px;
      color: #409eff ;
      text-align: center;
      font-weight: 400;
      width: 110px;
      height: 35px;
      background: #ffffff;
      border: 1px solid #409eff ;
      border-radius: 5px;
      margin-right: 20px;
    }
    .Select-p {
      background: rgba(97, 144, 232, 0.27);
    }
    .title-p {
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      background: transparent;
      border: none;
      margin-right: 0px;
    }
  }
  // 按钮样式
  .StartEditing-submit {
    width: 100%;
    height: 40px;
    display: flex;
    justify-content: flex-end;
    .Cancel {
      box-sizing: border-box;
      border: 1px solid #999999;
      color: #333333;
      margin-right: 20px;
    }
    .verify {
      background: #409eff ;
      color: #ffffff;
      cursor: pointer;
    }
    p {
      border-radius: 5px;
      font-family: PingFangSC-Medium;
      width: 120px;
      height: 40px;
      font-size: 16px;
      font-weight: 400;
      text-align: center;
      line-height: 40px;
    }
  }
}
</style>
